import { render, staticRenderFns } from "./queryFlowDirection.vue?vue&type=template&id=10b6c0a6"
import script from "./queryFlowDirection.vue?vue&type=script&lang=js"
export * from "./queryFlowDirection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports